import { createAction } from '@reduxjs/toolkit';

export type LocalActionEntryType = {
	data: any;
	class_name: string;
	deleted?: string[];
	last_update?: string;
	partialUpdate: boolean;
};

export const setOrderDetails = createAction<any>('setOrderDetails');

export const clearClassData = createAction<string>('clearClassData');

export const setDisconnected = createAction<boolean>('setDisconnected');

export const setShopifyClient = createAction<ShopifyBuy>('setShopifyClient');

export const setLocalData = createAction<LocalActionEntryType>('setLocalData');

export const setLiveUpdateStatus = createAction<boolean>('setLiveUpdateStatus');

export const setDigitalProducts = createAction<ShopifyBuy.Product[]>('setDigitalProducts');

export const setPhysicalProducts = createAction<ShopifyBuy.Product[]>('setPhysicalProducts');

export const setLoadings = createAction<{ init?: boolean; refresh?: boolean }>('setLoadings');

export const setShopifyCheckout = createAction<ShopifyBuy.Checkout | undefined>('setShopifyCheckout');

export const clearLocalStorage = createAction<{ init_loading?: boolean; refresh_loading?: boolean }>('clearLocalStorage');
